import { render } from "./MarketplaceHistory.vue?vue&type=template&id=2437a5ef&scoped=true"
import script from "./MarketplaceHistory.vue?vue&type=script&lang=js"
export * from "./MarketplaceHistory.vue?vue&type=script&lang=js"

import "./MarketplaceHistory.vue?vue&type=style&index=0&id=2437a5ef&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2437a5ef"]])

export default __exports__